import {onFind} from "@elements/init-modules-in-scope";
import {on} from "@elements/dom-utils";
import {getPrefixedDataSet} from "@elements/data-set-utils";

export function init() {
    onFind('.js-dropdown-tracking', function (baseElement) {
        let data = {};
        data = {
            ...data,
            ...getPrefixedDataSet('dropdown-tracking', baseElement)
        };

        let dataLayerData = {
            'event': 'genericGtmEvent',
            'genericEventCategory': data.category,
            'genericEventAction': data.action,
            'genericEventLabel': data.label
        };

        on('show.bs.dropdown', function() {
            window.dataLayer = window['dataLayer'] || [];
            let trackingData = {
                ...dataLayerData,
                ...{'genericEventLabel': "öffnen"}
            };
            window.dataLayer.push(trackingData);
        }, baseElement);

        on('hide.bs.dropdown', function() {
            window.dataLayer = window['dataLayer'] || [];
            let trackingData = {
                ...dataLayerData,
                ...{'genericEventLabel': "schließen"}
            };
            window.dataLayer.push(trackingData);
        }, baseElement)
    });
}